import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'ut-unified-registration-success',
  templateUrl: './success.component.html',
  standalone: false,
})
export class UnifiedRegistrationSuccessComponent implements OnInit {
  isCustomRegistration = false;
  customRegistration: any = null;
  user: any = null;
  embeddedFormUrl: string = '';

  constructor(
    @Inject('$transition$') private $transition$: any,
    @Inject('CustomRegistrationService') private CustomRegistrationService: any,
  ) { }

  ngOnInit(): void {
    const { customRegistrationId } = this.$transition$.params();

    if (customRegistrationId) {
      this.isCustomRegistration = true;

      this.user = this.CustomRegistrationService.getRegistrationUserData();

      this.CustomRegistrationService.find(customRegistrationId).then((response: any) => {
        this.customRegistration = response.data;
        this.updateEmbeddedFormUrl();
      });
    }
  }

  private updateEmbeddedFormUrl(): void {
    if (this.customRegistration && this.user) {
      const utmParams = this.getUtmParams();
      this.embeddedFormUrl = this.CustomRegistrationService.buildEmbeddedFormUrl(
        this.customRegistration.embedded_form,
        this.user,
        utmParams,
      );
    }
  }

  private getUtmParams(): any {
    const params: any = {};
    const routeParams = this.$transition$.params();

    if (routeParams.utm_source) params.utm_source = routeParams.utm_source;
    if (routeParams.utm_medium) params.utm_medium = routeParams.utm_medium;
    if (routeParams.utm_campaign) params.utm_campaign = routeParams.utm_campaign;
    if (routeParams.utm_content) params.utm_content = routeParams.utm_content;
    if (routeParams.utm_term) params.utm_term = routeParams.utm_term;

    return params;
  }
}
